import React from 'react';
import './documentCategories.scss';

import {Logout} from '../../globals';
import {useAuth} from  '../../contexts/auth'; 

import { createStore } from 'devextreme-aspnet-data';
import DataGrid, {
  Column,
  Editing,
  Selection,
  SearchPanel,
  Lookup
} from 'devextreme-react/data-grid';

import { useState, useEffect } from "react";

const serviceUrl = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/DocumentoCategoria'

const remoteDataSource = createStore({
    key: 'id',
    loadUrl: serviceUrl + '/GetAction',
    insertUrl: serviceUrl + '/InsertAction',
    updateUrl:serviceUrl + '/UpdateAction',
    deleteUrl: serviceUrl + '/DeleteAction'
    
});

export default function DocumentCategories() {
  
  const [ruoli, setRuoli] = useState({});

  const { user } = useAuth(); 

  if (!user) 
    Logout();

  useEffect(() => {
    
      const newServiceUrl1 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Roles';
      var newUrl1 =  newServiceUrl1 + "/GetAction";
  
  
      const fetchData = async () => {
        try {
  
          const requestOptions = {
            headers: {
              Authorization: `Bearer ${user.token}`
            }
          };
  
          const response1 = await fetch(newUrl1,requestOptions);
          const json1 = await response1.json();
          console.log(json1);
          setRuoli(json1);
  
        } catch (error) {
          console.log("error", error);
        }
      };
      fetchData();
    }, []);

    function onEditorPreparing(e) {
      if(e.dataField === "roleId" && e.parentType ==="dataRow") {
        e.editorOptions.showClearButton = true;
      }
    }

  return(

    
    <React.Fragment>
      <h2 className={'content-block'}>Categorie Documento</h2>
      <div className={'content-block'}>
        <div className={'dx-card responsive-paddings'}>
        <DataGrid
          dataSource={remoteDataSource}
          focusedRowEnabled={true}
          onEditorPreparing={onEditorPreparing}
        >
          
          <SearchPanel visible={true} width={240} placeholder="Cerca..." />
          <Selection mode="single" />
          <Editing
            mode="row"
            useIcons={true}
            allowAdding={true}
            allowDeleting={true}
            allowUpdating={true}     
          />
          <Column dataField="id" visible={false}/>
          <Column dataField="nome" />
          <Column dataField="roleId" caption="Ruolo Responsabile" visible={true}>
            <Lookup dataSource={ruoli} valueExpr="id" displayExpr="name" />
          </Column>
      
        </DataGrid>  
        </div>
      </div>
    </React.Fragment>
  )
};

